import declare from "dojo/_base/declare";
import StringTranslated from "csi/heading/StringTranslated";
import Locale from "../Locale";
import { Context } from "csi/def/Context";

export = declare(StringTranslated, {
	/** return the localized class name */
	_getTranslatedText(ctx: Context, value: string): string {
		return Locale.getTypeName(value);
	},

	/** return the localized class name along with the class since some localized names are not unique */
	_getTranslatedTextForFilter(ctx: Context, value: string): string {
		return `${Locale.getTypeName(value)} (${value})`;
	},
});